import { render, staticRenderFns } from "./NotificationOverview.vue?vue&type=template&id=51541974&scoped=true&"
import script from "./NotificationOverview.vue?vue&type=script&lang=ts&"
export * from "./NotificationOverview.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationOverview.vue?vue&type=style&index=0&id=51541974&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51541974",
  null
  
)

export default component.exports